import Main from "../../layouts/Main";
import Card from "../../components/Card";
import Tab from "../../components/Tab";
import SalaryIncreaseRecap from "./Recap/SalaryIncreaseRecap";
import Point from "./Point/Point";
import Bonus from "./Bonus/Bonus";
import SalaryIncreaseComplainClose from "./ComplainClose/complainclose";

const SalaryIncrease = () => {
  const data = [
    {
      name: "Rekap",
      id: "#tab1",
      content: <SalaryIncreaseRecap />,
    },
    {
      name: "Point",
      id: "#tab2",
      content: <Point />,
    },
    {
      name: "Bonus",
      id: "#tab3",
      content: <Bonus />,
    },
    {
      name: "Complain Close",
      id: "#tab4",
      content: <SalaryIncreaseComplainClose />,
    },
  ];

  return (
    <Main title="Penambahan Upah">
      <Card col={"col-xl-12 col-lg-12"}>
        <Tab data={data} defaultId={data[0].id} defaultContent={data[0].content} />
      </Card>
    </Main>
  );
};

export default SalaryIncrease;
